import { IMPERSONATE_ON, IMPERSONATE_OFF, SET_IMPERSONATE_ID, SET_IMPERSONATE_NAME, CAN_IMPERSONATE } from '../types';
import getImpersonationFromLS from '../../common/utility/getImpersonationFromLS';

const initialState = {
  canImpersonate: false,
  impersonate: Boolean(getImpersonationFromLS().impersonate),
  impersonateId: getImpersonationFromLS().impersonateId,
  impersonateName: getImpersonationFromLS().impersonateName,
};

const filtersReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMPERSONATE_ON:
      return {
        ...state,
        impersonate: true,
      };
    case IMPERSONATE_OFF:
      return {
        ...state,
        impersonate: false,
        impersonateId: '',
        impersonateName: '',
      };

    case SET_IMPERSONATE_ID:
      return {
        ...state,
        impersonateId: action.value,
      };

    case SET_IMPERSONATE_NAME:
      return {
        ...state,
        impersonateName: action.value,
      };

    case CAN_IMPERSONATE:
      return {
        ...state,
        canImpersonate: action.value,
      };

    default:
      return state;
  }
};

export default filtersReducer;
